import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/system";
import BryxColors from "../types/theme";
import BryxBox from "./BryxBox";
import BryxIcon from "./BryxIcon/BryxIcon";
const BryxSwitch = styled((props) => {
    let { checked, onClick, sx } = props;
    return (_jsx(BryxBox, { isFlex: true, centerAlignItems: true, sx: {
            height: "16px",
            width: "26.67px",
            backgroundColor: checked ? BryxColors.brand1("light") : BryxColors.specialColor("light").greyButGray,
            borderRadius: "8px",
            justifyContent: "flex-start",
            ...sx,
        }, className: "BryxSwitch", onClick: onClick, children: _jsx(BryxBox, { isFlex: true, centerAlignItems: true, sx: {
                transition: "all 0.15s linear",
                height: "16px",
                width: "16px",
                backgroundColor: BryxColors.background("light"),
                borderRadius: "8px",
                border: checked
                    ? `1px solid ${BryxColors.brand1("light")}`
                    : `1px solid ${BryxColors.specialColor("light").greyButGray}`,
                transform: checked ? "translate(10.66px)" : "rotate(-180deg)",
                justifyContent: "center",
            }, children: _jsx(BryxIcon, { iconName: "check", xsmIconSize: true, sx: { color: BryxColors.brand1("light"), opacity: checked ? 1 : 0, transition: "all 0.15s linear" } }) }) }));
})(({ theme, checked }) => {
    const palette = theme.palette.mode;
    return {};
});
export default BryxSwitch;
